import { useQuery } from 'react-query';
import Api from '../../../../shared/Api';

export function getOrders<T>() {
    return useQuery(['unbookedOrders'], () => new Api().get('/views/orders-list/unbookedv2'));
}
